import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight, Star, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gradient-to-b from-blue-50 to-white pt-20 pb-20 lg:pt-28 lg:pb-28" data-id="element-33">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-34">
        <div className="mx-auto max-w-6xl" data-id="element-35">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-36">
            {/* Text column */}
            <div className="text-center lg:text-left" data-id="element-37">
              <div className="inline-flex items-center rounded-full bg-blue-100 px-3 py-1 text-sm font-medium text-blue-800 mb-6" data-id="element-38">
                <Star className="mr-1 h-4 w-4 fill-blue-800" data-id="element-39" />
                Solución #1 Recomendada en Argentina
              </div>

              <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl mb-6 leading-tight" data-id="element-40">
                <span className="block text-primary" data-id="element-41">¿Dolor de juanetes?</span>
                Frená la deformidad hoy mismo sin pasar por el quirófano.
              </h1>

              <p className="mt-4 max-w-xl text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-42">
                El único sistema en Argentina que combina tecnología de
                alineación nocturna de grado médico con un protocolo nutricional
                para eliminar el "fuego" articular.
              </p>

              <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4 mb-10" data-id="element-43">
                <a href="#oferta" className="w-full sm:w-auto" data-id="element-44">
                  <Button variant="cta" size="xl" className="w-full group" data-id="element-45">
                    Quiero Aliviar Mi Dolor
                    <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-46" />
                  </Button>
                </a>
                <a href="#oferta" className="w-full sm:w-auto" data-id="element-47">
                  <Button variant="outline" size="xl" className="w-full text-gray-700 border-gray-300 hover:bg-gray-50" data-id="element-48">
                    Ver Cómo Funciona
                  </Button>
                </a>
              </div>

              <div className="flex flex-wrap justify-center lg:justify-start gap-5 text-sm text-gray-500 font-medium" data-id="element-49">
                <div className="flex items-center" data-id="element-50">
                  <ShieldCheck className="mr-2 h-5 w-5 text-green-500" data-id="element-51" />
                  Garantía de Satisfacción
                </div>
                <div className="flex items-center" data-id="element-52">
                  <ShieldCheck className="mr-2 h-5 w-5 text-green-500" data-id="element-53" />
                  Envío gratis a todo el país
                </div>
                <div className="flex items-center" data-id="element-54">
                  <ShieldCheck className="mr-2 h-5 w-5 text-green-500" data-id="element-55" />3
                  cuotas sin interés con Mercado Pago
                </div>
              </div>
            </div>

            {/* Product image column */}
            <div className="flex justify-center lg:justify-end" data-id="element-56">
              <div className="relative" data-id="element-57">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-200 to-teal-100 rounded-3xl blur-2xl opacity-60 scale-105" data-id="element-58"></div>
                <img src="https://cdn.magicpatterns.com/uploads/rMYFmEwVcLvLtkZ2rf38xd/1715617013-Bunion_Fix_Product_Photo_3_(1).webp" alt="Kit Pies Sin Presión — Corrector de juanetes de grado médico" className="relative z-10 w-full max-w-md rounded-2xl shadow-2xl object-contain bg-transparent" data-id="element-59" />
                <div className="absolute -bottom-4 -right-4 z-20 bg-white rounded-2xl shadow-xl px-4 py-3 flex items-center gap-2" data-id="element-60">
                  <span className="text-2xl" data-id="element-61">⭐</span>
                  <div data-id="element-62">
                    <p className="text-xs text-gray-500 leading-none" data-id="element-63">
                      Calificación
                    </p>
                    <p className="text-sm font-bold text-gray-900" data-id="element-64">
                      4.9 / 5 estrellas
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-65"></div>
      <div className="absolute bottom-0 right-0 translate-x-1/2 translate-y-1/2 w-96 h-96 bg-teal-100 rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-66"></div>
    </section>;
}